import { render, staticRenderFns } from "./ConfigApprovalList.vue?vue&type=template&id=c3481cc6&scoped=true&"
import script from "./ConfigApprovalList.vue?vue&type=script&lang=js&"
export * from "./ConfigApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigApprovalList.vue?vue&type=style&index=0&id=c3481cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3481cc6",
  null
  
)

export default component.exports